import { FormControlLabel, Radio, RadioGroupProps } from '@mui/material'
import { Field, useFormikContext } from 'formik'
import { RadioGroup } from 'formik-mui'
import { useTranslation } from 'react-i18next'

interface RadioBooleanFieldProps extends RadioGroupProps {
  name: string
  disabled?: boolean
}

export const RadioBooleanField = ({ name, ...props }: RadioBooleanFieldProps) => {
  const { t } = useTranslation('@cibo/ui/RadioBooleanField')
  const { isSubmitting } = useFormikContext()

  return (
    <Field name={name} component={RadioGroup} disabled={props.disabled} row>
      <FormControlLabel
        value={false}
        control={<Radio />}
        label={`${t('no')}`}
        disabled={props.disabled || isSubmitting}
        data-testid={`${name}::no`}
      />
      <FormControlLabel
        value={true}
        control={<Radio />}
        label={`${t('yes')}`}
        disabled={props.disabled || isSubmitting}
        data-testid={`${name}::yes`}
      />
    </Field>
  )
}
